import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { NumpadService } from 'packages/sports/web/app/src/numpad/numpad.service';

import { BetslipType } from '../../../../core/betslip-type';
import { PickId } from '../../../../core/picks/pick-id';
import { LINEAR_CONTAINER_STAKE_SERVICE } from '../../../stake/services/digital/linear/linear-container-stake.interface';
import { LINEAR_CONTAINER_SUMMARY_SERVICE } from '../../../summary/services/linear/linear-container-summary.interface';
import { SingleBetContainerStakeService } from '../../services/linear/single-bet-container-stake.service';
import { SingleBetContainerSummaryService } from '../../services/linear/single-bet-container-summary.service';

@Component({
    selector: 'bs-linear-single-bet-pick-summary',
    templateUrl: './linear-single-bet-pick-summary.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        NumpadService,
        SingleBetContainerStakeService,
        SingleBetContainerSummaryService,
        { provide: LINEAR_CONTAINER_SUMMARY_SERVICE, useExisting: SingleBetContainerSummaryService },
        { provide: LINEAR_CONTAINER_STAKE_SERVICE, useExisting: SingleBetContainerStakeService },
    ],
    standalone: false,
})
export class LinearSingleBetPickSummaryComponent implements OnInit {
    @Input() pickId: PickId;
    @Input() isDisabled: boolean;

    readonly betslipType = BetslipType.Single;

    constructor(
        private stakeService: SingleBetContainerStakeService,
        private summaryService: SingleBetContainerSummaryService,
    ) {}

    ngOnInit(): void {
        this.stakeService.init(this.pickId);
        this.summaryService.init(this.pickId);
    }
}
